import {Directive, HostListener} from '@angular/core';
import {FormControl, FormGroup, NgForm} from '@angular/forms';

@Directive({
    selector: 'form [tflInvalidControlNotifier]'
})
export class InvalidControlNotifierDirective {


    constructor(private _form: NgForm) {
    }

    @HostListener('submit', ['$event'])
    onSubmit(event) {
        if (!this._form.valid) {
            this.touchAllControls(this._form.form);
        }
    }

    private touchAllControls(fg: FormGroup) {
        Object.keys(fg.controls).forEach(controlName => {
            const control = fg.get(controlName);
            if (control instanceof FormControl) {
                control.markAsDirty();
            } else if (control instanceof FormGroup) {
                this.touchAllControls(control);
                control.updateValueAndValidity();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/invalid-control-notifier.directive.ts